import { render, staticRenderFns } from "./PFormDatepicker.vue?vue&type=template&id=2d4698b4&scoped=true&"
import script from "./PFormDatepicker.vue?vue&type=script&lang=ts&"
export * from "./PFormDatepicker.vue?vue&type=script&lang=ts&"
import style0 from "./PFormDatepicker.vue?vue&type=style&index=0&id=2d4698b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4698b4",
  null
  
)

export default component.exports